import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Tv3PlatformModule } from '@tokeet-frontend/tv3-platform'
import { DiscountCodeModule } from './store/discount-code/discount-code.module'
import { PermissionModule } from '@tokeet-frontend/permission'

const components = []
const dialogs = []

const services = []

const modules = [Tv3PlatformModule, DiscountCodeModule, PermissionModule]

@NgModule({
  imports: [CommonModule, ...modules],
  providers: [...services],
  declarations: [...dialogs, ...components],
  exports: [...modules, ...components],
})
export class DiscountCodeLibModule {}
